import { logError } from 'utils/logger';
import { useMutation } from '@apollo/client';
import { useNotifications } from 'modules/notification';
import { GraphqlResolverInput, MutationResponse } from 'global';
import {
  CreateCreditSubmissionDecisionInput,
  UpdateCreditSubmissionDecisionInput,
} from '@trnsact/trnsact-shared-types';

import { creditSubmissionDecisionApi } from './index';

export function useCSDecision() {
  const {} = useNotifications();

  const [onSubmitDecision, { loading: decisionSubmitting }] = useMutation<
    MutationResponse<any>,
    GraphqlResolverInput<CreateCreditSubmissionDecisionInput>
  >(creditSubmissionDecisionApi.create);

  const [onUpdateDecision, { loading: decisionUpdating }] = useMutation<
    MutationResponse<any>,
    { creditSubmissionDecisionId: string; input: UpdateCreditSubmissionDecisionInput }
  >(creditSubmissionDecisionApi.update);

  const handleSubmitDecision = async (dto: CreateCreditSubmissionDecisionInput) => {
    try {
      await onSubmitDecision({
        variables: {
          input: dto,
        },
      });
    } catch (error) {
      logError(error);
    }
  };

  const handleUpdateDecision = async (creditSubmissionDecisionId: string, dto: UpdateCreditSubmissionDecisionInput) => {
    try {
      await onUpdateDecision({
        variables: {
          creditSubmissionDecisionId,
          input: dto,
        },
      });
    } catch (error) {
      logError(error);
    }
  };

  return {
    decisionSubmitting,
    decisionUpdating,
    handleSubmitDecision,
    handleUpdateDecision,
  };
}
